<template>
  <main class="announcement-admin-page">
    <!-- Header Card -->
        <PageHeader icon="fas fa-tags">
      <template #title>
        Kategori Pengumuman {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola pengelompokan pengumuman yang digunakan di klinik
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                v-if="btn"
                @click="$router.push('/masters/announcement-categories/add')">
                <i class="fas fa-plus"></i>
                <span>Tambah Kategori</span>
              </b-button>
      </template>
    </PageHeader>

    <section class="announcement-admin-panel">
      <modern-filter-bar embedded single-line :show-timeseries="false"
        :search-text.sync="filter.name" search-placeholder="Cari kategori pengumuman"
        @search-keyup="filterByName" />

      <div class="announcement-admin-table">
        <medhop-data-table summary-title="Daftar Kategori Pengumuman"
          hover
          :items="items"
          :fields="fields"
          responsive="sm"
          show-empty
          empty-text="Belum ada kategori pengumuman">
          <template #table-colgroup="scope">
            <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.key === 'actions' ? '132px' : field.key === 'number' ? '64px' : '' }" />
          </template>
          <template #cell(name)="data">
            <div class="announcement-admin-primary-cell">
              <span class="announcement-admin-row-icon"><i class="fas fa-tag"></i></span>
              <span>{{ data.value }}</span>
            </div>
          </template>
          <template #cell(description)="data">
            <span class="announcement-admin-description">{{ data.value || '-' }}</span>
          </template>
          <template #cell(actions)="data">
            <div class="announcement-admin-actions">
              <b-button
                size="sm"
                v-b-tooltip.hover
                title="Detail"
                class="announcement-admin-action announcement-admin-action--view"
                @click="$router.push({ path: '/masters/announcement-categories/detail/' + data.item.id })">
                <i class="fas fa-eye"></i>
              </b-button>
              <b-button
                size="sm"
                v-if="btn"
                v-b-tooltip.hover
                title="Edit"
                class="announcement-admin-action announcement-admin-action--edit"
                @click="$router.push({ path: '/masters/announcement-categories/edit/' + data.item.id })">
                <i class="fas fa-edit"></i>
              </b-button>
              <b-button
                size="sm"
                v-if="btn"
                v-b-tooltip.hover
                title="Hapus"
                class="announcement-admin-action announcement-admin-action--delete"
                @click="deleteData(data.item.id)">
                <i class="fas fa-trash"></i>
              </b-button>
            </div>
          </template>
        </medhop-data-table>
      </div>

      <footer v-if="items.length != 0" class="announcement-admin-footer">
        <medhop-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          @page-click="pageOnClick" />
      </footer>
    </section>
  </main>
</template>

<script>

import { debouncer } from "@/core/modules/Helper.js"
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  name: "List",

  data() {
    return {
      // Filter
      filter: {
        name: ''
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
        },
        {
          key: "description",
          label: "Deskripsi",
          sortable: true,
        },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      // user access
      btn: false,
      clinic_name: window.configuration == null ? "Medhop" : window.configuration.clinic_name
    }
  },

  methods: {

    pageOnClick(page) {
      this.currentPage = page
      this.pagination()
    },

    async pagination() {
      let filterParams = `&name=${this.filter.name}`
      let response = await module.paginate('announcement-categories', `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      let pagination = response.meta.pagination
      this.totalRows = pagination.total

      let a, b
      b = this.perPage * (this.currentPage - 1) + 1
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a
      }

      this.items = response.data
    },

    filterByName() {
      debouncer(() => { this.currentPage = 1; this.pagination() }, 500)
    },

    async deleteData(id) {
      // Delete Data
      let result = await module.delete('announcement-categories/' + id)
      // If Deleted
      if (result) {
        this.pagination()
      }
    },

    setActiveButton() {
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "1802") {
          this.btn = true
        }
      }
    },

    testRootEmit() {
      this.$root.$emit("testRootEmit", this.fields)
    }

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Kategori Pengumuman" }])
    // Get Data
    this.pagination()
    this.setActiveButton()
  },

}

</script>

<style lang="scss" src="@/assets/sass/pages/_announcement-admin.scss"></style>
